import moment from 'moment';

export const formatDateObject = (dateInput) => {
  if (!dateInput) return "";
  let parsedDate;
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  if (typeof (dateInput) === 'string') {
    let formattedDate = "";
    const dateParts = dateInput.split("-");
    dateParts.forEach((part, index) => {
      if (index === dateParts.length - 1) {
        formattedDate += part;
      } else {
        formattedDate += part + "/";
      }
    });
    parsedDate = dateInput ? new Date(formattedDate) : null;
  } else {
    parsedDate = dateInput ? new Date(dateInput) : null;
  }
  if (!(parsedDate instanceof Date && !isNaN(parsedDate.valueOf()))) {
    parsedDate = dateInput ? new Date(dateInput) : null;
  }
  const day = parsedDate.getDate();
  const monthIndex = parsedDate.getMonth();
  const monthName = monthNames[monthIndex];
  const year = parsedDate.getFullYear();
  return `${monthName} ${day}, ${year}`;
};

export const formatCalenderDate = (value) => {
  if (value) {
    const date = new Date(value);
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  } else {
    return "";
  }
};

export const parseDateToFormat = (date, format) => {
  let formattedDate = '';
  if (date) {
    formattedDate = moment(date, "YYYY-MM-DD").format(format ? format.toUpperCase() : 'MM DD,YYYY');
  } else {
    formattedDate = format ? format.toUpperCase() : 'MM DD,YYYY';
  }
  return formattedDate;
};

export const convertDates = (match, year, month, day) => {
  const date = new Date();
  date.setFullYear(year, month - 1, day);
  const matchKey = match.split(':')[0];
  return `${matchKey}: "${date.toISOString()}"`;
};

export const compareDates = (parentCampaign, childCampaigns) => {
  let isDateMatched = true;
  const parentStartDate = new Date(parentCampaign.start_date);
  const parentEndDate = new Date(parentCampaign.end_date);
  for (let childCampaignObj of childCampaigns) {
    let childStartDate = new Date(childCampaignObj.start_date);
    let childEndDate = new Date(childCampaignObj.end_date);
    if (parentStartDate > childStartDate || parentEndDate < childEndDate) {
      isDateMatched = false;
      break;
    }
  }
  return isDateMatched;
};

export const convertToYYYYMMDD = (dateString) => {
  try {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn('Invalid date string:', dateString);
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error converting date:', error);
    return '';
  }
};

export const convertDateToDisplayFormat = (dateString) => {
  const date = new Date(dateString);
  const options = { month: "long", day: "numeric" };
  return new Intl.DateTimeFormat("en-US", options).format(date);
};

export const calculateDaysLeft = (dateString) => {
  if (!dateString) return 0;
  const date = new Date(dateString);
  const today = new Date();
  const diffTime = date - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};
